import { GameObj, KAPLAYCtx } from "kaplay";

export function playerSprite(k: KAPLAYCtx): GameObj {
  k.loadSprite("walk", "character/walk/walk2.png", {
    sliceX: 1,
    sliceY: 4,
    anims: {
      animate: { from: 0, to: 3, loop: true },
    },
  })

  k.loadSprite("idle", "character/idle/idle.png", {
    sliceX: 1,
    sliceY: 2,
    anims: {
      animate: { from: 0, to: 1, loop: true },
    },
  })

  k.loadSprite("jump", "character/jump/jump.png", {
    sliceX: 1,
    sliceY: 4,
    anims: {
      animate: { from: 0, to: 3, loop: true },
    },
  })


  const player = k.add([
    k.sprite("idle", {
      frame: 1,
      flipX: false,
      flipY: false,
      // animSpeed: 0.8 
      animSpeed: 0.4,
      // anim: "idle",
    }),
    k.pos(100, 300),
    k.scale(0.2),
    k.area({
      collisionIgnore: ["safety-platform"],
    }),
    k.body(),
    k.z(100),
    "player"
  ])

  return player
}
